<ng-container *ngIf="field">
  <div class="flex-auto input-field-container {{field.customClass}}">
    <label *ngIf="fieldOptions.label">{{ fieldOptions.label }}</label>

    <p-dropdown
      *ngIf="field.UIControl === 'Dropdown'"
	  [ngClass]="{'ng-invalid': control.invalid, 'ng-dirty': control.invalid}"
      [options]="field.options"
      [formControl]="control"
      [style]="{ width: '100%' }"
      (onChange)="onChange($event)"
      [placeholder]="fieldOptions.label"
	  [showClear]="field.UIOptions?.ShowClearButton"
	  [filter]="field.UIOptions?.ShowFilter"
	  appendTo="body"
	  optionLabel="label"
	  optionValue="value"
	  (onShow)="field.UIOptions?.LoadFromServer ? filterOptions($event): null"
    >
    </p-dropdown>

	<p-multiSelect
		*ngIf="field.UIControl === 'MultiSelect'"
		[ngClass]="{'ng-invalid': control.invalid, 'ng-dirty': control.invalid}"
		[options]="field.options"
		[formControl]="control"
		[style]="{ width: '100%' }"
		[maxSelectedLabels]="10"
		[optionLabel]="field.UIOptions.OptionLabel"
		(onChange)="onChange($event)"
		[placeholder]="fieldOptions.label"
		[showClear]="field.UIOptions?.ShowClearButton"
		[display]="field.UIOptions?.Display || 'chip'"
		[showToggleAll]="false"
		[resetFilterOnHide]="true"
		>
	</p-multiSelect>

    <p-autoComplete
      *ngIf="field.UIControl === 'Autocomplete'"
      [formControl]="control"
      [suggestions]="field.options"
	  [dropdown]="true"
      (completeMethod)="filterOptions($event)"
      field="name"
      [size]="350"
	  dataKey="id"
      (onSelect)="onSelect($event)"
	  [forceSelection]="true"
	  [showClear]="true"
	  [placeholder]="'Type to search a ' + fieldOptions.label"
    >
    </p-autoComplete>
  </div>
</ng-container>
